import React from 'react';
import './BbCountryCode.css';
import Dropdown from 'react-bootstrap/Dropdown';
// eslint-disable-next-line no-unused-vars
// import DropdownButton from 'react-bootstrap/DropdownButton';

class CountryCodes extends React.Component {
  constructor(props) {
    super(props);
    this.handleCountryCodeSelection = this.handleCountryCodeSelection.bind(this);
  }

  handleCountryCodeSelection = (eventkey) => {
    this.props.handleCountryCodeSelection(eventkey);
  };

  render() {
    return (
      <div>
        <div className="bb-selected-countrycode">
          Country determines game categories:
          <Dropdown onSelect={this.handleCountryCodeSelection}>
            <Dropdown.Toggle variant="success" id="dropdown-autoclose-true">
              {this.props.currentCC}
            </Dropdown.Toggle>

            <Dropdown.Menu variant="Success" className="bb-dd-menu">
              <Dropdown.Item eventKey="us" className="bb_dd_item">
                <img alt="US" className="bb-dd-img" src="/wp-content/uploads/2022/12/US.jpg" />
                US
              </Dropdown.Item>

              <Dropdown.Item eventKey="mx" className="bb_dd_item">
                <img alt="MX" className="bb-dd-img" width="40px" src="/wp-content/uploads/2022/12/MX-300x172.jpg" />
                MX
              </Dropdown.Item>

              <Dropdown.Item eventKey="fr" className="bb_dd_item">
                <img alt="FR" className="bb-dd-img" width="48px" src="/wp-content/uploads/2022/12/FR.jpg" />
                FR
              </Dropdown.Item>

              <Dropdown.Item eventKey="uk" className="bb_dd_item">
                <img alt="UK" className="bb-dd-img" width="48px" src="/wp-content/uploads/2023/05/uk.jpg" />
                UK
              </Dropdown.Item>

            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    );
  }
}

export default CountryCodes;
